module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_133883-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_ix"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_ix"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_133883-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_ix"
    }
  }, [_c('p', {
    staticClass: "title-other"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "chap-img5.png"
    }
  })])]), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847678164_tableofcontents"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "title-other"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "chap-img3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "paras hanging",
    attrs: {
      "id": "rw-paras-hanging_133883-00001"
    }
  }, [_c('p'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(". Joseph Grimaldi by J.E.T. Robinson, 1819 (Garrick Club/Art Archive)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(". "), _c('i', [_vm._v("Foire de Saint-Germain")]), _vm._v(" (Bibliothèque Nationale de France)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(". ‘Grim-All-Day at Breakfast’ by J. Berry, 1788 (© The Trustees of the British Museum. All rights reserved.)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(". Jean-Baptiste Dubois by Van Assen, 1794 (The British Library)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(". Dora Jordan by John Hoppner, 1791 (© National Portrait Gallery, London)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(". John Philip Kemble after Sir Thomas Lawrence, 1834 (© National Portrait Gallery, London)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(". Drury Lane Theatre from the Stage, 1804 (Royal College of Music, London)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(". ‘The Manager and His Dog’ by James Sayers, 1803 (© National Portrait Gallery, London)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(". South West View of Sadler’s Wells, 1792 (Harry Elkins Widener Collection, Harvard University, HEW 2.7.4)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(". Thomas John Dibdin by W. Owen, 1809 (University of Illinois Theatrical Print Collection, University of Illinois at Urbana-Champaign)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(". Charles Isaac Mungo Dibdin, junior, by R.W. Satchwell, 1819 (University of Illinois Theatrical Print Collection, University of Illinois at Urbana-Champaign)\n            ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(". Charles Farley as Cloten in "), _c('i', [_vm._v("Cymbeline")]), _vm._v(" by Thomas Charles Wageman, 1821 (University of Illinois Theatrical Print Collection, University of Illinois at Urbana-Champaign)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(". Mr Grimaldi as Orson (Robert Gould Shaw Collection, TS 937.8 F v.1, The Harvard Theatre Collection, Houghton Library)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(". ‘The Favourite Comic Dance of Messers Bologna Jun. and Grimaldi’ by Rudolph Ackermann, 1807 (V&A Images/Victoria and Albert Museum)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(". Grimaldi as Clown in "), _c('i', [_vm._v("Mother Goose")]), _vm._v(", c.1807 (Garrick Club/Art Archive)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(". Joseph Grimaldi by John Cawse, 1807 (© National Portrait Gallery, London)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(". ‘A View of the Confusion at Sadler’s Wells’, 1807 (The British Library)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(". Covent Garden Theatre by Pugin and Rowlandson, 1809 (Lebrecht Music and Arts)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(". ‘Killing No Murder, as Performed at the Grand National Theatre’ by George and Isaac Cruikshank, 1809 (© The Trustees of the British Museum. All rights reserved.)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(". Drury Lane Fire by Abraham Pether, 1809 (Guildhall Art Gallery, City of London)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(". ‘Mr. Grimaldi and Mr. Norman in the Epping Hunt’, 1813 (Lewis Walpole Library, Yale University)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(". ‘Grim Joey Dashing Little Boney into the Jaws of a Russian Bear’, 1813 (Harry Elkins Widener Collection, Harvard University, HEW 2.7.4)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(". ‘Mr. Grimaldi as Clown’ by Rudolph Ackermann, 1811 (Lewis Walpole Library, Yale University)\n            ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(". ‘Mr. Grimaldi as He Appeared When He Took His Farewell Benefit at Drury Lane Theatre on the 27th June, 1828’, by H. Brown, 1828 (Harry Elkins Widener Collection, Harvard University, HEW 2.7.4)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(". Grimaldi, Barnes and Ellar by H. Brown, 1823 (© The Trustees of the British Museum. All rights reserved.)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(". ‘Mr. H. Kemble as Aslan the Lion’, 1831–4 (Billy Rose Theatre Division, The New York Public Library for the Performing Arts, Astor, Lenox and Tilden Foundations)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(". ‘Mr. J.S. Grimaldi as Captain Corble in "), _c('i', [_vm._v("Paul Jones")]), _vm._v("’, by H. Brown, c.1830–32 (Harry Elkins Widener Collection, Harvard University, HEW 2.7.4)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(". ‘Mr. J.S. Grimaldi as Scaramouch’ by A. Chabot (V&A Images/Victoria and Albert Museum)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_16#rw-media-image_134111-00029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(". ‘Mr. Grimaldi as Clown’ by Dyer (V&A Images/Victoria and Albert Museum)\n            ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13b89070","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847678164_chapter_01.vue
// module id = 69
// module chunks = 0